type ImgixThumbnailOptions = {
  width?: number;
  height?: number;
  fit?: "max" | "crop";
};

const RETINA_PIXEL_RATIO = "2";

const isImgixUrl = (url: URL) =>
  url.hostname.endsWith(".imgix.net") ||
  (url.hostname === "media.mws.com" && url.pathname.startsWith("/imgix/"));

export const imgixThumbnail = (
  src: string | null | undefined,
  { width, height, fit = "max" }: ImgixThumbnailOptions,
): string | undefined => {
  if (!src) return undefined;

  let url: URL;
  try {
    url = new URL(src);
  } catch {
    return src;
  }

  if (
    !isImgixUrl(url) ||
    url.searchParams.has("s") ||
    url.pathname.toLowerCase().endsWith(".svg")
  ) {
    return src;
  }

  url.searchParams.set("auto", "format,compress");
  url.searchParams.set("dpr", RETINA_PIXEL_RATIO);
  url.searchParams.set("fit", fit);
  if (width) url.searchParams.set("w", String(width));

  if (height) url.searchParams.set("h", String(height));

  return url.toString();
};
